var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_profile-2user",
    "data-name": "vuesax/bulk/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z",
    transform: "translate(176.25 254)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z",
    transform: "translate(173.96 264.755)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z",
    transform: "translate(186.11 256.057)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z",
    transform: "translate(185.99 264.5)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.e1fbe7f0644236cd9165a2696bb48889.svg";
export { ForwardRef as ReactComponent };